import moment from "moment"
import { colors } from "../../../common/helper";

export const reportViewData = [
    { view: 'Detailed', id: 0 },
    { view: 'Summary', id: 1 },
    { view: 'Summary & Detailed', id: 2 },
]

export const pdfHeaderColumn = [
    { headerName: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Source Franchise City', exportHead: 'Source Franchise City', field: 'sourceCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Source Franchise Branch', exportHead: 'Source Franchise Branch', field: 'sourceBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Destination City', exportHead: 'Destination City', field: 'destinationCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Destination Branch', exportHead: 'Destination Branch', field: 'destinationBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left" },
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
]

export const excelHeader = [
    {headerName: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Source Franchise City', exportHead: 'Source Franchise City', field: 'sourceCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Source Franchise Branch', exportHead: 'Source Franchise Branch', field: 'sourceBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:2 },
    { headerName: 'Destination City', exportHead: 'Destination City', field: 'destinationCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Destination Branch', exportHead: 'Destination Branch', field: 'destinationBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:2 },
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
]
export const excelHeaderTwo = [
    { headerName: 'From Date', exportHead: 'From Date', field: 'fromDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'To Date', exportHead: 'To Date', field: 'toDate', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Source Franchise City', exportHead: 'Source Franchise City', field: 'sourceCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Source Franchise Branch', exportHead: 'Source Franchise Branch', field: 'sourceBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:2 },
    { headerName: 'Destination City', exportHead: 'Destination City', field: 'destinationCity', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Destination Branch', exportHead: 'Destination Branch', field: 'destinationBranch', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:2 },
    { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'paymentType', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:1 },
    { headerName: 'Report View', exportHead: 'Report View', field: 'reportView', xlCol: { dataType: 'number', dataFormatter: null },span:3, align: "left",colSpan:2 },
]

export const detailColumnsStyles = {
    0: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const detailColumnsStylesTwo = {
    0: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    1: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    2: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    6: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    7: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    8: { halign: 'left',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    9: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
    10: { halign: 'right',minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}

export const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
    const doc = data.doc
    // Footer
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

    var str = 'Page : ' + doc.internal.getNumberOfPages()
    if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
    }
    doc.setFontSize(16)
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
    doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
}
export const DetailsDrawCell=(data)=>{
    var rows = data.table.body
    rows.map((val) => {
        // colors[item.PaymentTypeID - 1]
        // val.cells[5].styles.fillColor=colors[val.raw.PaymentTypeID-1]
        if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right"
            } else {
                data.cell.styles.halign = "left"
            }
        }
        if (val.raw.isTotal) {
            val.cells[0].colSpan = 2
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor=[0,0,0]
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 9; i++) {
                val.cells[i].colSpan = 1
                val.cells[i].styles.font = 'Roboto'
                val.cells[i].styles.fontStyle = 'normal'
                val.cells[i].styles.fontSize = '16'
                val.cells[i].styles.textColor=[0,0,0]
                val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                val.cells[i].styles.fillColor = [238, 238, 238]
            }
        }
        if (val.raw.isSubHeading) {
            val.cells[0].colSpan = 10
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [233, 245, 255]
          }

    })
}
export const DetailsDrawCellTwo=(data)=>{
    var rows = data.table.body
    rows.map((val) => {
        // colors[item.PaymentTypeID - 1]
        // val.cells[5].styles.fillColor=colors[val.raw.PaymentTypeID-1]
        if (data.row.section === 'head') {
            if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right"
            } else {
                data.cell.styles.halign = "left"
            }
        }
        if (val.raw.isTotal) {
            val.cells[0].colSpan = 9
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor=[0,0,0]
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 10; i++) {
                val.cells[i].colSpan = 1
                val.cells[i].styles.font = 'Roboto'
                val.cells[i].styles.fontStyle = 'normal'
                val.cells[i].styles.fontSize = '16'
                val.cells[i].styles.textColor=[0,0,0]
                val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                val.cells[i].styles.fillColor = [238, 238, 238]
            }
        }
        if (val.raw.isGrandTotal) {
            val.cells[0].colSpan = 9
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontS0ze = '16'
            val.cells[0].styles.textColor=[0,0,0]
            val.cells[0].styles.halign = 'right'
            val.cells[0].styles.fillColor = [238, 238, 238]
            for (let i = 2; i <= 10; i++) {
                val.cells[i].colSpan = 1
                val.cells[i].styles.font = 'Roboto'
                val.cells[i].styles.fontStyle = 'normal'
                val.cells[i].styles.fontSize = '16'
                val.cells[i].styles.textColor=[0,0,0]
                val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                val.cells[i].styles.fillColor = [238, 238, 238]
            }
        }
        if (val.raw.isSubHeading) {
            val.cells[0].colSpan = 5
            val.cells[0].styles.font = 'Roboto'
            val.cells[0].styles.fontStyle = 'normal'
            val.cells[0].styles.fontSize = '16'
            val.cells[0].styles.halign = 'left'
            val.cells[0].styles.fillColor = [233, 245, 255]
            val.cells[5].colSpan = 6
            val.cells[5].styles.font = 'Roboto'
            val.cells[5].styles.fontStyle = 'normal'
            val.cells[5].styles.fontSize = '16'
            val.cells[5].styles.halign = 'right'
            val.cells[5].styles.fillColor = [233, 245, 255]
          }

    })
}

 export const PDFHeaderDetailedColumns = [
    { headerName: 'S/N', exportHead: 'S/N', field: 'SN', xlCol: { dataType: 'string', dataFormatter: null },span:1, align: "left",width:"30px" },
    { headerName: 'LR No\nMan. LR No.', exportHead: 'LR No\nMan. LR No.', field: 'LRManLRno', xlCol: { dataType: 'string', dataFormatter: null },span:1, align: "left",width:"60px" },
    { headerName: 'Bkg. Date\nBkg. Time', exportHead: 'Bkg. Date\nBkg. Time', field: 'BKGDateTime', xlCol: { dataType: 'string', dataFormatter: null },span:2, align: "left",width:"75px"  },
    { headerName: 'Src. City\nSrc. Br.', exportHead: 'Src. City\nSrc. Br.', field: 'SrcCityBranch', xlCol: { dataType: 'string', dataFormatter: null },span:2, align: "left",width:"120px"  },
    { headerName: 'Dst. City\nDst. Br', exportHead: 'Dst. City\nDst. Br', field: 'DestCityBranch', xlCol: { dataType: 'string', dataFormatter: null },span:2, align: "left",width:"120px"  },
    { headerName: 'Sndr. Name\nSndr. Contact', exportHead: 'Sndr. Name\nSndr. Contact', field: 'SenNameMob', xlCol: { dataType: 'string', dataFormatter: null },span:2, align: "left",width:"80px"  },
    { headerName: 'Rcvr. Name\nRcvr. No', exportHead: 'Rcvr. Name\nRcvr. No', field: 'RecNameMob', xlCol: { dataType: 'string', dataFormatter: null },span:1, align: "left",width:"80px"  },
    { headerName: 'Pymt.\nType', exportHead: 'Pymt.\nType', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null },span:1, align: "left",width:"40px"  },
    { headerName: 'LR\nStatus', exportHead: 'LR\nStatus', field: 'Status', xlCol: { dataType: 'string', dataFormatter: null },span:1, align: "left",width:"80px"  },
    { headerName: 'Item\nUnits', exportHead: 'Item\nUnits', field: 'Items', xlCol: { dataType: 'number', dataFormatter: null },span:1, align: "right",width:"30px" },
    { headerName: 'Net.\nAmt.', exportHead: 'Net\nAmt', field: 'NetAmount', xlCol: { dataType: 'number', dataFormatter: null, halign: "right" },span:2, align: "right",width:"50px" },
 ]